<template lang="pug">
.container
  .row
    h2.main_title Production Detail
      .pull-right
        button.btn.btn-primary(v-on:click="handleShowModal('upload')" v-if="user.role === 'admin'")
          span.glyphicon.glyphicon-plus
          span  New
    .col-md-12.function_bar(style="display:flex; justify-content: space-between;")
      .form-group
        label.control-label
          | Model:
        input.form-control(style="display: inline-block; width: 180px;" v-model="searchModelTxt" placeholder="Search Model")
        span.text-danger(style="display: block; padding-left: 52px;" v-if="!searchModelObj.isValid") Not a proper model name.
      .form-group
        label.control-label
          | Category:
        v-select(v-bind:value.sync="logFilter.category.value" v-bind:options="logFilter.category.opts" @change="resetFilter()")
      //- .form-group
        label.control-label
          | Family:
        v-select(v-bind:value.sync="logFilter.family.value" v-bind:options="logFilter.family.opts")
      .form-group
        label.control-label
          | Custom:
        v-select(v-bind:value.sync="logFilter.custom.value" v-bind:options="logFilter.custom.opts")
      .form-group(v-if="user.role === 'admin'")
        label.control-label
          | Status:
        v-select(v-bind:value.sync="logFilter.status.value" v-bind:options="logFilter.status.opts")
    spinner(v-ref:spinner size="md" show="true" text="Loading...")
    div(ng-if="deviceLoaded && mibLoaded")
      pagination(
        v-bind:sort-method.sync="sortMethod"
        v-bind:sort-method-opts="sortMethodOpts"
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='statusFilteredTotalLog'
      )
      .col-md-12
        table.table.table-bordered.table-hover.log_table(v-if="!(typeof user.custom === 'undefined' && typeof user.role === 'undefined')")
          tr(v-for="($index, d) in statusFilteredTotalLog  | limitBy countOfPage pageStart")
            td {{$index + 1 + pageStart}}
            td.single_log
              .media
                .media-left
                  .media-object.device_icon(v-bind:class="d.category")
                    img(v-bind:src="getIconSrc(d.category)")
                .media-body
                  .media-top(style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px;")
                    div(style="display: inline-block;")
                      h4.text-secondary(style="margin-bottom: 0;") {{d['.key']}}
                        tooltip(effect="scale" placement="top" content="Board")
                          span.badge(v-if='d.board.length !== 0') {{ d.board }}
                        tooltip(effect="scale" placement="top" content="Family")
                          //- span.badge(v-if='d.family.length !== 0') {{ d.family }}
                        tooltip(effect="scale" placement="top" content="Status")
                          span.badge(v-if="getLabel('status', d.status, true).length !== 0" v-bind:style="{backgroundColor: d.status === 'release' ? '#00C851' : '#ffbb33'}") {{ getLabel('status', d.status, true) }}
                      .time
                        span.glyphicon.glyphicon-time
                        span(v-if="sortMethod.name !== 'updatedAt'") Released at {{d.createdAt | fromNow }}
                        span(v-if="sortMethod.name === 'updatedAt'") Updated at {{ d.updatedAt | fromNow }}
                    .action_buttons.pull-right
                      .btn-group
                        button.btn.btn-sm.btn-default(@click="handleShowModal('update', d['.key'], $index)" v-if="['admin'].includes(user.role)")
                          span.glyphicon.glyphicon-pencil
                        button.btn.btn-sm.btn-default(@click="handleShowDeleteConfirm(d['.key'], d.category)" v-if="['admin'].includes(user.role)")
                          span.glyphicon.glyphicon-trash
                        dropdown
                          button.btn.btn-sm.btn-default.dropdown-toggle(slot="button" type="button")
                            span.glyphicon.glyphicon-cloud-download
                            span  Firmware
                          ul.dropdown-menu(slot="dropdown-menu")
                            li(v-for="(key, value) in d.firmware" v-bind:class="{'disabled': value.version == null}")
                              a(@click="handleDownload(value.url, $event)")
                                | {{ getCustomForUI(key) || key }}
                                .badge(v-bind:style="{backgroundColor: value.version == null ? '#ddd' : '' }") {{ value.version == null ? 'None' : value.version }}
                        button.btn.btn-sm.btn-default.dropdown-toggle(type="button" @click="handleShowDownloadModal(d['.key'])" v-bind:disabled="getVersionOptsLength(d['.key']) === 0")
                          i.fa.fa-download
                          span  Private MIB
                  .media-middle
                    .row
                      .col-md-12
                        h5(style="color: #888; margin-bottom: 4px; margin-top: 0;")
                          strong.type CUSTOM
                        p(style="margin-top: 6px;")
                          span.label.label-info(v-for="cu in d.custom" style="margin-right: 6px;") {{getCustomForUI(cu)}}
                      .col-md-12
                        line-table(title='DESCRIPTION' v-bind:content='d.description' v-if='d.description.length !== 0')
        .col-md-12(v-if="statusFilteredTotalLog.length <= 0")
          h3.text-center.text-muted No Data
    modal(
      v-bind:title.sync='modalTitle'
      v-bind:ok-text.sync='okText'
      backdrop='false'
      v-bind:callback='modalCb'
      v-bind:show.sync='showModal'
    )
      .modal-body.upload_modal(slot='modal-body')
        .col-md-12.clearfix.col-centered
          .form-group.col-md-12.clearfix(v-if='isUpdate')
            .col-md-3.form-label.clearfix
              label.control_label
                | Last update:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='isUpdatedAt' readonly)
          .form-group.col-md-12.clearfix
            .col-md-3.form-label.clearfix
              label.control_label
                | Release Date:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm(v-model='isReleasedAt' readonly v-if="user.role !== 'admin'")
              datepicker(v-bind:value.sync="isReleasedAt" v-bind:format="'yyyy/M/dd'" placeholder="Default is current time." v-else)
          .form-group.col-md-12.clearfix.version
            .col-md-3.form-label.clearfix
              label.control-label
                | Name:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm.col-md-3(v-model='name' placeholder='')
          .form-group.col-md-12.clearfix
            .col-md-3.form-label.clearfix
              label.control-label
                | Category:
            .col-md-9.no_pad.clearfix
              v-select(v-bind:options='category' v-bind:value.sync='selectedCategory')
          //- .form-group.col-md-12.clearfix.version
            .col-md-3.form-label.clearfix
              label.control-label
                | Family:
            .col-md-8.no_pad.clearfix
              v-select(v-bind:options='familyOptions' v-bind:value.sync='selectedFamily' v-bind:disabled="selectedCategory === null")
            .col-md-1.pull-right.upload
              button.btn.btn-primary(v-on:click="showAddFamilyModal = true" v-if="user.role === 'admin'" v-bind:disabled="selectedCategory === null")
                span.glyphicon.glyphicon-plus
          //- .form-group.col-md-12.clearfix.version
            .col-md-3.form-label.clearfix
              label.control-label
                | Model:
            .col-md-8.no_pad.clearfix
              v-select(v-bind:disabled="selectedFamily === null" v-bind:options='modelOptions' v-bind:value.sync='selectedModel')
            .col-md-1.pull-right.upload
              button.btn.btn-primary(v-on:click="showAddModelModal = true" v-if="user.role === 'admin' && selectedFamily")
                span.glyphicon.glyphicon-plus
          .form-group.col-md-12.clearfix.version
            .col-md-3.form-label.clearfix
              label.control-label
                | Custom:
            .col-md-9.no_pad.clearfix
              v-select(v-bind:options='custom' multiple v-bind:value.sync='selectedCustom')
          .form-group.col-md-12.clearfix
            .col-md-3.form-label.clearfix
              label.control-label
                | Status:
            .col-md-9.no_pad.clearfix
              v-select(v-bind:options='statusOpts' v-bind:value.sync='selectedStatus')
          .form-group.col-md-12.clearfix.version
            .col-md-3.form-label.clearfix
              label.control-label
                | Board:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm.col-md-3(v-model='board' placeholder='')
          .form-group.col-md-12.clearfix.version
            .col-md-3.form-label.clearfix
              label.control-label
                | Firmware:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm.col-md-3(placeholder='Will auto retrieve the lastest Firmware.' readonly)
          .form-group.col-md-12.clearfix.version
            .col-md-3.form-label.clearfix
              label.control-label
                | Private MIB:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm.col-md-3(placeholder='Will auto retrieve the mateched Private MIB.' readonly)
          .form-group.col-md-12.clearfix.version
            .col-md-3.form-label.clearfix
              label.control
                | MMS CID:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm.col-md-3(v-model='mmsCid' placeholder='(Optional)')
          .form-group.col-md-12.clearfix.version
            .col-md-3.form-label.clearfix
              label.control-label
                | Description:
            .col-md-9.no_pad.clearfix
              input.form-control.input-sm.col-md-3(v-model='description' placeholder='(Optional)')
    modal(
    title='Confirm'
    v-bind:show.sync='showDeleteConfirm'
    )
      .modal-body(slot='modal-body')
        h4.text-center Are you sure to delete ?
      .modal-footer(slot='modal-footer')
        button.btn.btn-default(@click='showDeleteConfirm = false')
          | No
        button.btn.btn-danger(@click='applyDelete')
          | Yes
    modal(
    title='Add family'
    v-bind:show.sync='showAddFamilyModal'
    ok-text='Add'
    v-bind:callback='applyUploadFamily'
    )
      .modal-body(slot='modal-body')
        .col-md-12.clearfix.col-centered
          .form-group.col-md-12
            .col-md-3.form-label
              label.control-label
                | Family name:
            .col-md-9.no_pad
              input.form-control.input-sm.col-md-3(v-model='newFamilyInfo')
    modal(
    title='Add model'
    v-bind:show.sync='showAddModelModal'
    ok-text='Add'
    v-bind:callback='applyUploadModel'
    )
      .modal-body(slot='modal-body')
        .col-md-12.clearfix.col-centered
          .form-group.col-md-12
            .col-md-3.form-label
              label.control-label
                | Model name:
            .col-md-9.no_pad
              input.form-control.input-sm.col-md-3(v-model='newModelInfo')
    modal(
      title='Select Private MIB'
      backdrop='false'
      v-bind:show.sync='showDownloadModal'
    )
      .modal-body.upload_modal(slot='modal-body')
        .col-md-12.clearfix.col-centered
          .form-group.col-md-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | Version:
            .col-md-9.no_pad.clearfix
              v-select(
                v-bind:value.sync="downloadTarget.filter.version"
                v-bind:options="downloadTarget.versionOpts"
                options-value="val"
                search close-on-select
              )
          .form-group.col-md-12.clearfix
            .col-md-3.form_label.clearfix
              label.control_label
                | Layer:
            .col-md-9.no_pad.clearfix
              v-select(options-value="val" v-bind:value.sync="downloadTarget.filter.layerMode" v-bind:options="layerModeOpts")
      .modal-footer.upload_modal(slot='modal-footer')
        button.btn.btn-default(@click="cancelDownloadModal") Cancel
        button.btn.btn-primary(@click="downalodMib" v-bind:disabled="downloadTarget.filter.layerMode == null || downloadTarget.filter.version == null || mibUrlLoadingState === 1") {{ mibUrlLoadingState === 0 ? 'Download' : mibUrlLoadingState === 1 ? 'Loading...' : mibUrlLoadingState === 2 ? 'Downloading' : 'Error'}}
    alert(v-bind:show.sync="showAlert" placement="top" duration="5000" type="danger" width="400px" dismissable)
      span(class="icon-info-circled alert-icon-float-left")
      h4 The field below are required:
        ul
          li(v-if="name === ''") Name
          li(v-if="selectedCategory === null") Category
          li(v-if="selectedFamily === null") Family
          li(v-if="selectedCustom === null") Custom
          li(v-if="selectedStatus === null") Status
          li(v-if="board === ''") Board
</template>

<script>
import moment from 'moment'
import { alert, datepicker, dropdown, modal, select, tooltip, spinner } from 'vue-strap'
import pagination from '../common/Pagination.vue'
import lineTable from '../common/LinedTable.vue'
import {
  getFireBase,
  /* getNetworkDeviceRef,  */getNetworkModelRef, getNetworkFamilyRef,
  getCustomForUI, getIconSrc, getDb, store, filterOptions, naturalSorting, snmpOidDocOpts
} from '../../index.js'
import _ from 'lodash'

const fb = getFireBase()

export default {
  components: {
    alert,
    datepicker,
    dropdown,
    lineTable,
    modal,
    'v-select': select,
    tooltip,
    pagination,
    spinner
  },
  vuex: {
    getters: {
      user: state => state.user
    }
  },
  firebase () {
    return {
      model: getNetworkModelRef(),
      family: getNetworkFamilyRef()
    }
  },
  data () {
    return {
      firebase_firmware: [],
      pmib: [],
      device: [],
      deviceLoaded: false,
      mibLoaded: false,
      logFilter: {
        category: {
          opts: [],
          value: 'any'
        },
        family: {
          opts: [],
          value: 'any'
        },
        custom: {
          opts: [{label: 'Any', value: 'any'}, ...(filterOptions.custom)],
          value: 'any'
        },
        status: {
          opts: [{label: 'Any', value: 'any'}, ...(filterOptions.status.product)],
          value: 'any'
        }
      },
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      sortMethod: {
        name: 'createdAt',
        asc: false
      },
      sortMethodOpts: [
        {
          label: 'Sort by Release Date',
          value: 'createdAt'
        },
        {
          label: 'Sort by Update Time',
          value: 'updatedAt'
        },
        {
          label: 'Sort by Category',
          value: 'category'
        },
        // {
        //   label: 'Sort by Custom',
        //   value: 'custom'
        // },
        // {
        //   label: 'Sort by Family',
        //   value: 'family'
        // },
        {
          label: 'Sort by Model Name',
          value: 'board'
        }
      ],
      name: null,
      description: null,
      custom: filterOptions.custom,
      selectedCustom: null,
      category: filterOptions.category,
      selectedCategory: null,
      selectedFamily: null,
      // selectedModel:       status: filterOptions.status.product,
      selectedStatus: null,
      board: null,
      firmware: null,
      privateMIB: null,
      mmsCid: null,
      showModal: false,
      modalTitle: '',
      okText: '',
      modalCb () {},
      editingKey: '',
      showDeleteConfirm: false,
      isUpdate: false,
      showAddFamilyModal: false,
      newFamilyInfo: null,
      showAddModelModal: false,
      newModelInfo: null,
      showAlert: false,
      statusOpts: filterOptions.status.product,
      snmpOidDocOpts,
      isUpdatedAt: '',
      isReleasedAt: '',
      searchModelTxt: '',
      downloadTarget: {
        candidates: {},
        filter: {
          layerMode: null,
          model: null,
          version: null
        },
        versionOpts: []
      },
      showDownloadModal: false,
      mibUrlLoadingState: 0
    }
  },
  ready () {
    this.$refs.spinner.show()
    this.$watch(
      function () {
        return this.deviceLoaded && this.mibLoaded
      },
      function (newVal, oldVal) {
        if (oldVal === false && newVal === true) {
          this.$refs.spinner.hide()
        } else {
          this.$refs.spinner.show()
        }
      }
    )
    if (['pandacom@lantechcom.tw', 'db@lantechcom.tw'].includes(this.user.email)) {
      this.logFilter.category.opts = [{label: 'RouterX', value: 'routerx'}]
    } else {
      this.logFilter.category.opts = _.cloneDeep(filterOptions.category)
    }
    this.logFilter.category.opts.unshift({label: 'Any', value: 'any'})

    if (this.user.custom != null) {
      this.getData(this.user.custom)
    }
  },
  computed: {
    categorizedFamily () {
      return _.transform(this.family, (result, value, index) => {
        const { '.key': fam, '.value': cate } = value
        if (result[cate] == null) result[cate] = []
        result[cate].push(fam)
      }, {})
    },
    familyOptions () {
      const opts = []
      if (['any', null].includes(this.selectedCategory)) {
        this.family.map((f) => {
          opts.push(
            {
              label: f['.key'],
              value: f['.key']
            }
          )
        })
      } else {
        let cf = this.categorizedFamily[this.selectedCategory] || []
        this.family.map((f) => {
          if (cf.includes(f['.key'])) {
            opts.push({label: f['.key'], value: f['.key']})
          }
        })
      }
      return opts
    },
    modelOptions () {
      const opts = []
      this.model.map((m) => {
        if (m.family === this.selectedFamily) {
          opts.push({
            label: m['.key'],
            value: m['.key']
          })
        }
      })
      return opts
    },
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    },
    searchModelObj () {
      if (/^[a-zA-Z0-9-]+$/.test(this.searchModelTxt)) {
        return {
          isValid: true,
          value: this.searchModelTxt
        }
      } else if (this.searchModelTxt === '') {
        return {
          isValid: true,
          value: ''
        }
      } else {
        return {
          isValid: false,
          value: ''
        }
      }
    },
    totalLog () {
      if (this.deviceLoaded && this.mibLoaded) {
        let firmwareData = this.firebase_firmware
        let deviceData = this.device
        // console.log('deviceData', deviceData)
        // console.log('firmwareData', firmwareData)
        // add Firmware latest download link to Dataset.

        // specific filter pandacom
        deviceData.map(e => {
          e.firmware = {}
          e.mib = {}
          if (this.user.role === 'client') {
            e.custom = _.pick(e.custom, [this.user.custom, this.user.email === 'eu@lantechcom.tw' ? 'lantech_pandacom' : null]) // HACK: the multi-custom access workarround for this account
          }
          for (let cu in e.custom) {
            let fw = _.filter(firmwareData, {category: e.category, custom: cu, status: 'release'})
            let latestFW = naturalSorting(fw, 'version', 'desc')[0]
            e.firmware[cu] = {
              version: (typeof latestFW === 'undefined') ? null : latestFW.version,
              url: (typeof latestFW === 'undefined') ? null : latestFW.url
            }
          }
        })
        const { name, asc: isAsc } = this.sortMethod
        if (name === 'model') {
          return naturalSorting(deviceData, 'model', isAsc ? 'asc' : 'desc')
        } else {
          return _.orderBy(deviceData, [name], [isAsc ? 'asc' : 'desc'])
        }
      } else {
        return []
      }
    },
    categoryFilteredTotalLog () {
      return this.totalLog.filter(p => {
        return this.logFilter.category.value !== 'any' ? p.category === this.logFilter.category.value : true
      })
      .filter(x => {
        if (this.searchModelObj.isValid) {
          if (this.searchModelObj.valud === '') return true
          return x['.key'].toLowerCase().indexOf(this.searchModelObj.value.toLowerCase()) !== -1
        } else {
          return true
        }
      })
    },
    familyFilteredTotalLog () {
      let defaultOpts = [{label: 'Any', value: 'any'}]
      if (this.logFilter.category.value === 'any') {
        this.family.map(ele => {
          defaultOpts.push({label: ele['.key'], value: ele['.key']})
        })
      } else {
        let cf = this.categorizedFamily[this.logFilter.category.value] || []
        this.family.map(ele => {
          if (cf.includes(ele['.key'])) {
            defaultOpts.push({label: ele['.key'], value: ele['.key']})
          }
        })
      }
      this.logFilter.family.opts = defaultOpts
      return this.categoryFilteredTotalLog.filter(p => {
        return this.logFilter.family.value !== 'any' ? p.family === this.logFilter.family.value : true
      })
    },
    customFilteredTotalLog () {
      if (!(this.user.custom == null && this.user.role == null)) {
        switch (this.user.role) {
          case 'admin':
            break
          default: // client, vendor
            this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'carrier_switch')
            this.logFilter.category.opts = _.filter(this.logFilter.category.opts, (obj) => obj.value !== 'viewer')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'intrising')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'microsens_npd7')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value !== 'sercomm_dragon')
            this.logFilter.custom.opts = _.filter(this.logFilter.custom.opts, (obj) => obj.value === 'any' || /* obj.value.toLowerCase() === 'lantech' || */ obj.value.toLowerCase() === this.user.custom.toLowerCase() || (this.user.email === 'eu@lantechcom.tw' && obj.value === 'lantech_pandacom'))
            break
        }
        return this.familyFilteredTotalLog.filter((p = {custom: {}}) => {
          // console.log(
          //   p,
          //   this.logFilter.custom.value,
          //   p.custom.includes(this.logFilter.custom.value),
          //   _.find(this.logFilter.custom.opts, (opt) => p.custom.includes(opt.value)) != null, 'a'
          // )
          return this.logFilter.custom.value !== 'any'
          ? p.custom[this.logFilter.custom.value] != null
          // filter data in user permission custom option
          : _.find(this.logFilter.custom.opts, (opt) => p.custom[opt.value] != null) != null
        })
      } else {
        return []
      }
    },
    statusFilteredTotalLog () {
      switch (this.user.role) {
        case 'admin':
          return this.customFilteredTotalLog.filter(p => {
            return this.logFilter.status.value !== 'any' ? p.status === this.logFilter.status.value : typeof (_.find(this.logFilter.status.opts, {value: p.status})) !== 'undefined'
          })
        default:
          return this.customFilteredTotalLog.filter(p => {
            return p.status === 'release'
          })
      }
    },
    layerModeOpts () {
      const { version, model } = this.downloadTarget.filter
      if (version == null) {
        return [
          { label: 2, val: 2 },
          { label: 3, val: 3 }
        ]
      } else {
        const [c, v] = version.split('|')
        const {l2, l3} = (this.pmib.filter(x => x.version === v && x.custom === c)[0]).models.filter(y => y.model === model)[0]
        const result = []
        if (l2) result.push({ label: 2, val: 2 })
        if (l3) result.push({ label: 3, val: 3 })
        return result
      }
    }
  },
  methods: {
    keysss (o) {
      // console.log(o)
      return _.keys(o)
    },
    getCustomForUI,
    getLabel (type, val, isProd) {
      let target
      if (type === 'status') target = filterOptions[type][isProd ? 'product' : 'firmware']
      else target = filterOptions[type]
      return _.find(target, {value: val}).label
    },
    handleDownload (url, e) {
      // console.log('download', url)
      window.open(url)
    },
    handleShowModal (which, key, index) {
      this.editingKey = key
      if (which === 'upload') {
        this.isUpdate = false
        this.modalTitle = 'Add device'
        this.okText = 'Add'
        this.name = ''
        this.board = ''
        this.mmsCid = ''
        this.description = ''
        this.isReleasedAt = moment(new Date()).format('YYYY/MM/DD HH:mm:ss')
        this.modalCb = this.applyUpload

        this.selectedCustom = null
        this.selectedFamily = null
        this.selectedCategory = null
        this.selectedStatus = null
        // this.selectedModel = null
      } else if (which === 'update') {
        this.isUpdate = true
        this.modalTitle = 'Update device'
        let { custom, family, category, status, /* model, */ board, mmsCid, description, updatedAt, createdAt } = this.statusFilteredTotalLog[index + this.pageStart]
        this.okText = 'Update'
        this.name = this.statusFilteredTotalLog[index + this.pageStart]['.key']
        this.isUpdatedAt = ''
        this.isUpdatedAt = moment(updatedAt).format('YYYY/MM/DD HH:mm:ss')
        this.isReleasedAt = ''
        this.isReleasedAt = moment(createdAt).format('YYYY/MM/DD HH:mm:ss')
        this.selectedCustom = Object.keys(custom)
        this.selectedFamily = family
        this.selectedCategory = category
        this.selectedStatus = status
        // this.selectedModel = model
        this.board = board
        this.mmsCid = mmsCid
        this.description = description
        this.modalCb = this.applyUpdate
      }
      this.showModal = true
    },
    applyUpload () {
      /* check if null */
      const check = _.includes({
        custom: this.selectedCustom,
        // family: this.selectedFamily,
        // model: this.selectedModel,
        category: this.selectedCategory,
        status: this.selectedStatus
      }, null) || this.name === '' || this.board === ''

      if (check) {
        this.showAlert = true
      } else {
        const toPush = {
          createdAt: fb.database.ServerValue.TIMESTAMP,
          updatedAt: fb.database.ServerValue.TIMESTAMP,
          custom: _.transform(this.selectedCustom, (result, x, i) => { result[x] = x }, {}),
          // family: this.selectedFamily,
          // model: this.selectedModel,
          category: this.selectedCategory,
          status: this.selectedStatus,
          board: this.board.trimLeft().trimRight(),
          mmsCid: this.mmsCid,
          description: this.description.trimLeft().trimRight()
        }
        getDb().ref('product').child(this.name.trimLeft().trimRight()).set(toPush)
        this.showModal = false
      }
    },
    async applyUpdate () {
      let { createdAt } = _.find(this.device, {'.key': this.editingKey})
      const update = {
        createdAt: createdAt,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        custom: _.transform(this.selectedCustom, (result, x, i) => { result[x] = x }, {}),
        // family: this.selectedFamily,
        // model: this.selectedModel,
        category: this.selectedCategory,
        status: this.selectedStatus,
        board: this.board,
        // let backend control these
        // firmware: this.firmware,
        // privateMIB: this.privateMIB,
        mmsCid: this.mmsCid,
        description: this.description
      }
      // getDb().ref('product').update(update)
      let ref = getDb().ref('product')
      ref.child(this.name).set(update)
      if (this.name !== this.editingKey) ref.child(this.editingKey).remove()
      this.showModal = false
    },
    handleShowDeleteConfirm (key) {
      this.editingKey = key
      this.showDeleteConfirm = true
    },
    applyDelete () {
      getDb().ref('product').child(this.editingKey).remove()
      this.showDeleteConfirm = false
    },
    firmwareRedirect (category, custom) {
      store.dispatch('firmwareInfoSelected', {
        category,
        custom
      })
      this.$route.router.go('/firmware')
    },
    mibRedirect (d) {
      store.dispatch('mibInfoSelected', {
        category: d.category,
        custom: d.custom,
        family: d.family
      })
      this.$route.router.go('/privateMIB')
      // need to redirect to the clicked page
    },
    applyUploadFamily () {
      this.$firebaseRefs.family.child(this.newFamilyInfo).set(this.selectedCategory)
      this.newFamilyInfo = null
      this.showAddFamilyModal = false
    },
    applyUploadModel () {
      this.$firebaseRefs.model.child(this.newModelInfo).set({family: this.selectedFamily})
      this.newModelInfo = null
      this.showAddModelModal = false
    },
    resetFilter () {
      this.logFilter.family.value = 'any'
      this.logFilter.custom.value = 'any'
    },
    getIconSrc,
    getVersionOptsLength (model) {
      return this.pmib.filter(x => x.models.some(y => y.model === model)).length
    },
    handleShowDownloadModal (model) {
      this.downloadTarget.filter.model = model
      this.downloadTarget.versionOpts = this.pmib.filter(x => x.models.some(y => y.model === model)).map(z => ({ label: `${getCustomForUI(z.custom)} - ${z.version}`, val: `${z.custom}|${z.version}` }))
      this.showDownloadModal = true
    },
    cancelDownloadModal () {
      this.showDownloadModal = false
      this.downloadTarget = {
        filter: {
          layerMode: null,
          model: null,
          version: null
        },
        versionOpts: []
      }
    },
    async downalodMib () {
      const {
        filter: { layerMode, model, version }
      } = this.downloadTarget
      let cv = version.replace('|', '_')
      const key = `${cv.replace(/\./g, '!')}_${model}_l${layerMode}`
      this.mibUrlLoadingState = 1
      const url = await fb.database().ref('mib/download').child(key).once('value').then((sn) => sn.val())
      this.mibUrlLoadingState = 2
      window.open(url)
      this.showDownloadModal = false
      this.mibUrlLoadingState = 0
    },
    getData (custom) {
      const isEu = this.user.email === 'eu@lantechcom.tw'  // HACK: the multi-custom access workarround for this account
      let query = {
        fw: [
          getDb().ref('firmware'),
          getDb().ref('firmware').orderByChild('custom').startAt(custom).endAt(custom)
        ],
        device: [
          getDb().ref('product'),
          getDb().ref('product').orderByChild(`custom/${custom}`).equalTo(custom)
        ],
        pmib: [
          getDb().ref('mib/entry'),
          getDb().ref('mib/entry').orderByChild('custom').startAt(custom).endAt(custom)
        ]
      }

      const i = ['admin', 'vendor'].includes(this.user.role) || isEu ? 0 : 1
      query.fw[i].off()
      query.fw[i].on(
        'value',
        (sn) => {
          this.$refs.spinner.hide()
          this.firebase_firmware = _.transform(sn.val(), (result, value, key) => {
            result.push({
              '.key': key,
              ...value
            })
          }, []).filter(x => isEu ? ['lantech_lantech', 'lantech_pandacom'].includes(x.custom) : true)
        },
        () => {
          query.fw[i].off()
        }
      )
      query.device[i].off()
      query.device[i].on(
        'value',
        (sn) => {
          this.$refs.spinner.hide()
          this.device = _.transform(sn.val(), (result, value, key) => {
            result.push({
              '.key': key,
              ...value
            })
          }, []).filter(x => {
            if (isEu) {
              if (x.custom.lantech_pandacom === 'lantech_pandacom') console.log(x)
              if (x.custom.lantech_lantech === 'lantech_lantech') return true
              if (x.custom.lantech_pandacom === 'lantech_pandacom') return true
              else return false
            } else {
              return true
            }
          })
          this.deviceLoaded = true
        },
        () => {
          query.device[i].off()
        }
      )
      query.pmib[i].off()
      query.pmib[i].on(
        'value',
        (sn) => {
          this.$refs.spinner.hide()
          this.pmib = _.transform(sn.val(), (result, value, key) => {
            if (this.user.role !== 'admin' && value.status !== 'release') return
            result.push({
              '.key': key,
              ...value
            })
          }, []).filter(x => isEu ? ['lantech_lantech', 'lantech_pandacom'].includes(x.custom) : true)
          this.mibLoaded = true
        },
        () => {
          query.pmib[i].off()
        }
      )
    }
  },
  watch: {
    logFilter: {
      deep: true,
      handler: function (nv) {
        this.currPage = 1
        this.currPaginationSec = 1
      }
    },
    'user.custom' (curr, prev) {
      if (curr != null) {
        this.getData(curr)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../scss/_varaibles.scss';
@import '../../scss/_mixin.scss';
.filter{
  margin-bottom: 15px;
}
.table{
  & th, & td {
    vertical-align: middle;
  }
  & th {
    background-color: #f8f8f8;
  }
  // .model, .board, .firmware {
  //   text-align: left;
  // }
  .firmware .isLink {
    text-decoration: underline;
    cursor: pointer;
  }
  .firmware-padding {
    padding-right: 5px;
  }
}
h1{
  text-transform: capitalize;
}
.total, .upload{
  text-align: right;
}

.control-label{
  padding-right: 5px;
}
.glyphicon {
  cursor:pointer;
}

.glyphicon-upload{
  font-size: 20px;
}
.firmware {
  .dl-horizontal {
    margin-bottom: 0;
  }
  .dl-horizontal dt {
    width: 80px;
  }
  .dl-horizontal dd {
    width: 90px;
    margin-left: 90px;
    margin-bottom: 4px;
    button {
      margin-right: 4px;
    }
  }
}

.main_table{
  padding-bottom: 70px;
}

.upload_modal .form_label, .total, .function_bar .upload{
  text-align: right;
}
.function_bar {
  .upload{
    font-size: 20px;
  }
  .form-group{
    float: left;
  }
}
.form_label{
  padding: 5px 15px;
  white-space: nowrap;
}
.control_label{
  padding-right: 5px;
}

.upload_modal{
  .download{
    margin-left: -9px;
    margin-right: 9px;
  }
  .form-group{
    margin-bottom: 3px;
  }
  .form-group.larger_form_group{
    margin-bottom: 7px;
  }
}
.action_buttons{

}
.log_table{
  td {
    padding: 15px;
  }
  .media-top{

  }
  .version{
    display: inline-block;
    // width: 130px;
    padding:3px 7px 3px 0px;
    font-size: 20px;
  }
  .time{
    color: #d7d7d7;
    padding-right:5px;
    .glyphicon{
      font-size: 10px;
      cursor: default;
      padding-right:5px;
    }
    span{
      font-size: 12px;
    }
  }
  span.download{
    cursor:pointer;
    span{
      font-size: 14px;
    }
  }
}
textarea{
  min-height: 200px;
  resize: vertical;
}
.warning{
  padding: 3px 5px;
  color: #fff;
  background-color: #f00;
}
.single_log{
  position: relative;
  // overflow: hidden;
}
.badge_group{
  padding-right: 40px;
}
.customized__badge{
  &.develop{
    @include genRightCornerBadge(50px, 18px, 14px, $warning, #000);
    right:-56px;
  }
  &.release{
    @include genRightCornerBadge(50px, 18px, 14px, $success, #fff);
    right:-50px;
  }
}
.error{
  border:2px solid #e33;
}
.err_msg{
  padding-right: 7px;
  padding-left: 7px;
  & span{
    display: inline-block;
    white-space: nowrap;
    line-height: 30px;
    font-size: 12px;
    width:100%;
    height:30px;
    background-color: #e33;
    color: #fff;
    padding: 0px 7px;
  }
}
.largerTotalLength {
  font-size: 18px;
  font-weight: bolder;
  padding-top: 3px;
  padding-bottom: 3px;
}
.media-body,
.media {
    overflow: visible; /*overflow was set to hidden before */
}

.media-body:after,
.media:after {
    clear: both;
    content: ' ';
    display: block;
    height: 0;
}

.type_tag{
  padding-top: 0;
  padding-bottom: 0;
}
.type {
  color: #000;
  width: 85px;
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// Production.vue?b25bd1ae